import TrackingPage from './TrackingPage';
export default TrackingPage; 